import { TFunction } from 'i18next';
import {
  ErrorType,
  Section,
  isErrorType,
  SearchSuggest,
} from '../../../../components/molecules/Form/components/ComboBox';

import { isEmptyArray, isNotNullOrUndefined, isNullOrUndefined } from '../../../../lib/typeGuards';

import { SearchSuggestResult } from '../../../../components/molecules/Form/components/ComboBox/AbstractComboBox/types/SuggestResultTypes';
import { murmurhash } from '../../../../lib/js/hash';

export default (t: TFunction) =>
  (
    key: 'searchSuggestions',
    containsAreaSearch: boolean,
    searchSuggestResponse?: SearchSuggest | ErrorType
  ): Section<SearchSuggestResult>[] => {
    if (
      isNullOrUndefined(searchSuggestResponse) ||
      isErrorType(searchSuggestResponse) ||
      isEmptyArray(searchSuggestResponse)
    ) {
      return [];
    }

    const searchSuggestResults: SearchSuggestResult[] = searchSuggestResponse.map(searchSuggest => ({
      id: murmurhash(searchSuggest.name),
      type: 'searchSuggestResult',
      pageLink: searchSuggest,
      title: searchSuggest.name,
    }));

    const filteredResults = searchSuggestResults.filter(isNotNullOrUndefined);
    return [
      {
        key,
        results: filteredResults,
        headline: !containsAreaSearch ? t(`${key}.headline`) : t(`${key}.headlineAreaSearch`),
      },
    ];
  };
